import { React } from 'react';

import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

import ComercialCRM from '../../components/comercialCRM';

const GerarProposta = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Box className={!isMobile ? 'mainBox' : ''}>
            <ComercialCRM />
        </Box>
    );
};

export default GerarProposta;
